export default "__VITE_ASSET__GaKpnhrQ__"